import React from 'react'

import Section from '../../../../../../components/Section'

type Props = {
    theme: string
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    annotationContract: string | null
    onAnnotationContractChange: (value: string | null) => void
}

const ContractCardAnnotation: React.FC<Props> = (props) => {
    const updateContract = async (updatedField: Record<string, any>) => {
        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    '/api/backend/v1/contract/' +
                    encodeURIComponent(props.contractGuid),
                {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatedField),
                }
            )
            if (!response.ok) {
                throw new Error('Ошибка обновления данных в базе')
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleAnnotationChange = (value: string) => {
        if (value == '') {
            props.onAnnotationContractChange(null)
            updateContract({ annotation: null })
        } else {
            props.onAnnotationContractChange(value)
            updateContract({ annotation: value })
        }
    }

    return (
        <Section title="Примечание к договору">
            <div className="flex flex-col w-full gap-x-5 mt-2">
                <div className="flex flex-col  min-w-[200px] ">
                    <label className="mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Примечание
                    </label>
                    <textarea
                        className="form-textarea "
                        maxLength={2000}
                        rows={3}
                        value={props?.annotationContract || ''}
                        onChange={(e) => handleAnnotationChange(e.target.value)}
                    />
                </div>
            </div>
        </Section>
    )
}

export default ContractCardAnnotation
